import React, { useState } from "react";
import "./PartnerWithUsComparison.css"; // Custom CSS
import { Link } from "react-router-dom";

const plans = ["Classified", "Silver", "Gold", "Platinum"];

const planData = {
    Silver: {
        price: "₹24000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "Upto 10 bids/month",
            "Single",
            "10%",
            "✔️",
            "✔️",
            "Multiple",
            "4%",
        ],
    },
    Gold: {
        price: "₹36000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "100 bids/month",
            "Multiple (2x)",
            "25%",
            "✔️",
            "✔️",
            "Multiple",
            "3%",
        ],
    },
    Classified: {
        price: "₹48000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "Unlimited",
            "Unlimited",
            "0%",
            "✔️",
            "✔️",
            "Multiple",
            "0%",
        ],
    },
    Platinum: {
        price: "₹48000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "Unlimited",
            "Unlimited",
            "10%",
            "✔️",
            "Venue wise",
            "Multiple",
            "4%",
        ],
    },
};

const featuresTitle = [
    "Bidding Limit",
    "Bidding Attempts per Lead",
    "Bid Price Range",
    "Bidding Rejection Trend",
    "Bid Closure Status",
    "Package Showcasing",
    "Party Witty Pay Charges",
];

const PartnerWithUsComparison = () => {
    const [activeTab, setActiveTab] = useState("Classified");

    return (
        <div className="partner-with-us-comparison-section">
            <h1>Comparison</h1>

            {/* Mobile Tabs */}
            <div className="partner-with-us-mobile-tabs">
                {plans.map((plan) => (
                    <div
                        key={plan}
                        className={`partner-with-us-tab ${activeTab === plan ? "active" : ""
                            }`}
                        onClick={() => setActiveTab(plan)}
                    >
                        {plan}
                    </div>
                ))}
            </div>

            {/* Mobile View: Single Column Table */}
            <div className="partner-with-us-mobile-table">
                <div className="partner-with-us-plan-header">
                    <h3>{activeTab}</h3>
                    <p className="partner-with-us-trial">{planData[activeTab].trial}</p>
                    <h4>
                        {planData[activeTab].price}{" "}
                        <span className="partner-with-us-note">
                            {planData[activeTab].note}
                        </span>
                    </h4>
                    <Link to='/business-registration'><button className="partner-with-us-select">Select</button></Link>
                </div>
                <table>
                    <tbody>
                        {featuresTitle.map((feature, i) => (
                            <tr key={i}>
                                <td>{feature}</td>
                                <td>{planData[activeTab].features[i]}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Desktop View: Full Table */}
            <table className="partner-with-us-comparison-table-container">
                <thead>
                    <tr className="partner-with-us-comparison-table-header">
                        <th></th>
                        {plans.map((plan) => (
                            <th key={plan}>
                                <div className="partner-with-us-comparison-table-header-content">
                                    <h3>{plan}</h3>
                                    <p className="partner-with-us-trial">
                                        {planData[plan].trial}
                                    </p>
                                    <h4>
                                        {planData[plan].price}{" "}
                                        <span className="partner-with-us-note">
                                            {planData[plan].note}
                                        </span>
                                    </h4>
                                    <Link to='/business-registration'><button className="partner-with-us-select">Select</button></Link>
                                    {/* <Link to='/business-registration' className="partner-with-us-select">Select</Link> */}
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {featuresTitle.map((feature, i) => (
                        <tr key={i} className="partner-with-us-comparison-table-row">
                            <td>{feature}</td>
                            {plans.map((plan) => (
                                <td key={plan}>{planData[plan].features[i]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PartnerWithUsComparison;
